import React, { useState, lazy, Suspense } from "react";

import { BookOpen, Eye, LayoutGrid, Trash2 } from "lucide-react";

import Modal from "../ui/Modal";

const PdfViewer = lazy(() => import("../common/pdf/PdfViewer"));

const DOC_ICONS = {
  brochure: BookOpen,
  "floor-plan": LayoutGrid,
};

export default function PropertyDocumentSection({
  label,
  url,
  variant = "brochure",
  hasExtractData = false,
  isAdmin = false,
  onUpdateExtract,
  onDelete,
  isDeletePending = false,
  viewerTitle = "Document",
}) {
  const [showPdf, setShowPdf] = useState(false);
  const Icon = DOC_ICONS[variant] || BookOpen;

  if (!url) return null;

  return (
    <>
      <div className={`property-doc-row is-${variant}`}>
        <div className="property-doc-identity">
          <span
            className={`property-doc-icon property-doc-icon--${variant}`}
            aria-hidden="true"
          >
            <Icon size={18} strokeWidth={1.85} />
          </span>
          <span className="property-doc-label">{label}</span>
        </div>

        <div className="property-doc-segment" role="group" aria-label={`${label} actions`}>
          <button
            type="button"
            className="property-doc-seg"
            onClick={() => setShowPdf(true)}
            aria-label={`View ${label}`}
            title="View"
          >
            <Eye size={16} strokeWidth={1.75} />
          </button>

          {isAdmin && (    
              <button
                type="button"
                className="property-doc-seg property-doc-seg--danger"
                onClick={onDelete}
                disabled={isDeletePending}
                aria-label={`Delete ${label}`}
                title="Delete file and extracted data"
              >
                <Trash2 size={16} strokeWidth={1.75} />
              </button>
          )}
        </div>
      </div>

      {showPdf && (
        <Modal
          isOpen={showPdf}
          className="brochure-viewer-modal"
          onClose={() => setShowPdf(false)}
          title={viewerTitle}
        >
          <Suspense fallback={<div>Loading PDF...</div>}>
            <PdfViewer fileUrl={url} height="90vh" />
          </Suspense>
        </Modal>
      )}
    </>
  );
}
